module.exports = __webpack_public_path__ + "static/media/search-icon-expand.c6106642.svg";